import { curatorStudentsApiSlice } from './curatorStudents'

export type StudentEventType = 'VIDEO' | 'TEST' | 'CONSPECT' | 'HOMEWORK' | 'PRACTICE' | 'ZACHET'

// bff: поля чужого типа события и «не задано» -> null
export interface StudentEvent {
    type: StudentEventType
    // yyyy-MM-ddTHH:mm:ss по Алматы; null у практики и зачёта (известна только неделя)
    at: string | null
    title: string | null
    subjectTitleKz: string | null
    subjectTitleRu: string | null
    reachedPercent: number | null
    totalPercent: number | null
    watchedSeconds: number | null
    point: number | null
    maxPoint: number | null
    attempt: number | null
    passed: boolean | null
    status: string | null
    status2: string | null
    monthNumber: number | null
    weekNumber: number | null
    checked: boolean | null
}

export interface StudentActivityDay {
    day: string
    loggedIn: boolean
    requests: number
    events: StudentEvent[]
}

export interface StudentActivityFeed {
    userCourseEnrollId: number
    userId: number
    from: string
    to: string
    lastSeenAt: string | null
    idleDays: number | null
    activeDays: number
    trackedSince: string | null
    days: StudentActivityDay[]
}

export interface LastSeen {
    userId: number
    lastSeenAt: string | null
    idleDays: number | null
}

// С этого числа дней без входа - красным
export const IDLE_ALERT_DAYS = 3

export const studentActivityApi = curatorStudentsApiSlice
    .enhanceEndpoints({ addTagTypes: ['StudentActivity'] })
    .injectEndpoints({
        endpoints: (build) => ({
            fetchStudentActivity: build.query<StudentActivityFeed, { userCourseEnrollId: number; days: number }>({
                query: ({ userCourseEnrollId, days }) => ({ url: `student-activity/${userCourseEnrollId}`, params: { days } }),
                transformResponse: (response: { data: StudentActivityFeed }) => response.data,
                providesTags: (_r, _e, { userCourseEnrollId }) => [{ type: 'StudentActivity', id: userCourseEnrollId }],
            }),
            fetchLastSeen: build.query<LastSeen[], number[]>({
                query: (userIds) => ({ url: `student-activity/last-seen`, params: { userIds: userIds.join(',') } }),
                transformResponse: (response: { data: LastSeen[] }) => response.data ?? [],
            }),
        }),
    })
